const SetupSequence = () => {
    return (
        <div id="bot-scene-container" className="">
            <div id="bot-scene-content" className="scroll-light">
                <div className="app-v2-header-wrapper has-subtitle has-extra">
                    <div className="app-v2-header-left">
                        <span className="app-v2-header-title">
                            Kịch bản chăm sóc</span>
                        <span className="app-v2-header-subtitle">
                            Giữ chân khách hàng tiềm năng và chăm sóc khách hàng theo từng giai đoạn của hành trình khách hàng.
                            <a href="" target="_blank">
                                Tìm hiểu thêm
                            </a>
                        </span>
                    </div>
                    <div className="app-v2-header-extra-wrapper">
                        <button className="btn btn-primary p-sm-l p-sm-r app-v2-gtm-auto-keyword-new ml15">
                            <span>
                                Tạo kịch bản
                            </span>
                        </button>
                    </div>
                </div>

                <div className="app-v2-layout-content">
                    <div>
                        <div className="hrs-filter-container-master">
                            <div className="hrs-filter-container">
                                <div className="hrs-filter-wrapper">
                                    <div className="hrs-btn-open-filter">
                                        <div className="svg-next-icon icon-filter">
                                        </div>
                                        <span>Bộ lọc tìm kiếm</span>
                                    </div>
                                </div>
                                <div className="hrs-filter-search-wrapper">
                                    <svg width="16" height="16" viewBox="0 0 16 16">
                                        <path fill="#8993A4" fillRule="evenodd"
                                            d="M6.8 13.6a6.8 6.8 0 115.34-2.59l3.626 3.624a.8.8 0 01-1.132 1.132L11.01 12.14A6.77 6.77 0 016.8 13.6zm3.728-3.175a.817.817 0 00-.103.103 5.2 5.2 0 11.102-.102z"
                                            clipRule="evenodd"></path>
                                    </svg >
                                    <input className="hrs-filter-input-search" placeholder="Tìm kiếm" value="" />
                                </div>
                            </div>
                        </div>

                        <div className="app-table-container ref-parameters--container app-scrollbar app-scrollbar-visible">
                            <table className="app-table app-table--vertical-middle">
                                <thead>
                                    <th style={{ width: "105px" }}>Kích hoạt</th>
                                    <th >Tên kịch bản</th>
                                    <th className="text-right" style={{ width: "135px" }}>Số người đăng ký</th>
                                    <th className="text-right" style={{ width: "100px" }}>Số tin nhắn</th>
                                    <th className="text-right" style={{ width: "100px" }}>Đã đọc</th>
                                    <th className="text-right" style={{ width: "100px" }}>CTR</th>
                                    <th className="text-right" style={{ width: "120px" }}>Hành động</th>
                                </thead>

                                <tbody>
                                    <tr className="app-v2-table-row">
                                        <td>
                                            <div className="input-switch input-switch-on keyboard-input-ctrl"><label>
                                                <div className="input-checkbox text-center checked">
                                                    <div className="svg-next-icon icon-check ic-check">
                                                    </div>
                                                    <div className="svg-next-icon ic-box">
                                                    </div>
                                                </div><i></i>
                                            </label></div>
                                        </td>
                                        <td className="pointer">
                                            <div className="sequence-table-container__column-name">
                                                <span className="text-overflow-ellipsis line-height-20">
                                                    <span className="title-hover"
                                                        title="Kịch bản gửi lại cho Khách hàng đã đăng ký Thông báo định kỳ"
                                                    >Kịch bản gửi lại cho Khách hàng đã đăng ký Thông báo định kỳ
                                                    </span>
                                                </span>
                                            </div>
                                        </td>
                                        <td className="text-right pointer" style={{ width: "135px" }}>
                                            <div>0</div>
                                        </td>
                                        <td className="text-right pointer">
                                            <div className="sequence-table-container__column-width">3</div>
                                        </td>
                                        <td className="text-right pointer">
                                            <div className="sequence-table-container__column-width">0.0%</div>
                                        </td>
                                        <td className="text-right pointer" style={{ width: "100px" }}>
                                            <div className="sequence-table-container__column-width">0.0%</div>
                                        </td>
                                        <td className="text-right pointer" style={{ width: "120px", padding: "20px" }}>
                                            <div>
                                                <a className="hover-alert icon-delete ml8 mr8 pointer text-note">
                                                    <i>
                                                        <svg ariaHidden="true" focusable="false"
                                                            dataprefix="far" dataicon="trash-alt"
                                                            className="svg-inline--fa fa-trash-alt fa-w-14 " role="img"
                                                            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style={{ width: 12 }}>
                                                            <path fill="currentColor"
                                                                d="M268 416h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12zM432 80h-82.41l-34-56.7A48 48 0 0 0 274.41 0H173.59a48 48 0 0 0-41.16 23.3L98.41 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16v336a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM171.84 50.91A6 6 0 0 1 177 48h94a6 6 0 0 1 5.15 2.91L293.61 80H154.39zM368 464H80V128h288zm-212-48h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12z">
                                                            </path>
                                                        </svg>
                                                    </i>
                                                </a>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="table-wrapper">
                            <div className="app-report-table--pagination">
                                <div className="app-pagination ">
                                    <div className="app-pagination--options">
                                        <div className="app-pagination-dropdown">
                                            <div className="app-pagination-dropdown--text">Hiển thị</div>
                                            <div className="app-pagination-dropdown--btn">
                                                <div className="app-pagination-dropdown--number">20</div>
                                                <div className="app-pagination-dropdown--icon">
                                                    <svg className="app-svg-inline-block app-svg-next-icon-rotate-90" width="16px"
                                                        height="16px" viewBox="0 0 16 16">
                                                        <path d="M6.47 4L5.53 4.94L8.58333 8L5.53 11.06L6.47 12L10.47 8L6.47 4Z">
                                                        </path>
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <ul className="app-pagination--listpage">
                                        <li className="app-pagination-total-text">Đang hiển thị 1-1 /  8 </li>
                                        <li className="app-pagination--item app-pagination--item-active">
                                            <a>1</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SetupSequence;